import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import Select from '../../../../components/Select/Select';
import SelectDealPaymentStatuses from '../../../../components/Selects/selectDealPaymentStatuses';
import { DEAL_STATUS_CAR_ISSUED, DOCUMENT_TYPES_INVOICE } from '../../../../constants';

const HalykCarDelivery = ({ onSubmit, loading }) => {
  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <HookForm
          title={'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
              name: 'status',
              component: Select,
              options: [
                {
                  value: DEAL_STATUS_CAR_ISSUED,
                  label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð²ÑÐ´Ð°Ð½Ð°',
                },
              ],
              required: true,
            },
          ]}
          onSubmit={onSubmit}
          loading={loading}
        />
      </div>
    </>
  );
};

export default HalykCarDelivery;
